import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Select } from '@material-ui/core';
import { MenuItem } from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import responsibleKindShipList from '../../validate/responsibleKindShipList';

function ResponsibleKinshipSelection(props) {
  const { t } = props;
  const { type, changeHandler } = props;
  const menuItems = responsibleKindShipList(t).map((item) => (
    <MenuItem key={item.value} value={item.value}>
      {item.label}
    </MenuItem>
  ));
  return (
    <MuiThemeProvider>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={type}
        onChange={(event) => changeHandler(event.target.value)}
      >
        {menuItems}
      </Select>
    </MuiThemeProvider>
  );
}

ResponsibleKinshipSelection.propTypes = {
  t: PropTypes.func.isRequired,
  changeHandler: PropTypes.func.isRequired,
  type: PropTypes.string,
};

ResponsibleKinshipSelection.defaultProps = {
  type: 'U',
};

export default withTranslation('common')(ResponsibleKinshipSelection);
